<template>
    <div class="card center">
        <Sidebar v-model:visible="visible" position="right">
            <template #container="{ closeCallback }">
                <div class="sidebar-container">
                    <div class="header">
                        <span class="branding">
                            <img class="logo" src="/images/logo.png" alt="">
                        </span>
                        <Button icon="pi pi-times" @click="closeCallback" class="close-button" />
                    </div>
                    <div class="menu-content">
                        <ul class="menu-list">
                            <!-- <li v-for="route in routes">
              <router-link :to="route.path" >{{ route.name }}</router-link>
            </li> -->
                            <li class="menu-section"><router-link to="/">{{ $t('route1') }}</router-link></li>
                            <li class="menu-section"><router-link to="/services">{{ $t('route2') }}</router-link></li>
                            <li class="menu-section"><router-link to="/references">{{ $t('route3') }}</router-link></li>
                            <li class="menu-section"><router-link to="/fences">{{ $t('route5') }}</router-link></li>
                            <li class="menu-section"><router-link to="/contact">{{ $t('route4') }}</router-link></li>
                        </ul>
                    </div>
                </div>
                <div class="footer">
                    <div class="header-icons">

                        <div class="langs">
                            <img ref="husideRef" class="lang" src="images/hun.png" alt="HU" @click="$i18n.locale = 'hu', changeLang('hu')" />
                            <img ref="ensideRef" class="lang" src="images/eng.jpg" alt="EN" @click="$i18n.locale = 'en', changeLang('en')" />
                        </div>
                    </div>
                </div>
            </template>
        </Sidebar>
        <Button icon="pi pi-bars" @click="visible = true" class="menu-button"/>
    </div>
</template>

<script setup>
import Sidebar from 'primevue/sidebar';
import Button from 'primevue/button';
import { ref, watchEffect, nextTick } from "vue";

const props = defineProps({
    onHomePage: {
        type: Boolean,
        default: false
    }
})

const husideRef = ref(null);
const ensideRef = ref(null);

const checkLang = () => {
    const lang = localStorage.getItem('locale') || 'hu';

    nextTick(() => {
        if (husideRef.value && ensideRef.value) {
            if (lang === 'hu') {
                husideRef.value.classList.add('choosed-lang');
                ensideRef.value.classList.remove('choosed-lang');
            } else {
                ensideRef.value.classList.add('choosed-lang');
                husideRef.value.classList.remove('choosed-lang');
            }
        }
    });
};

const changeLang = (lang) => {
    localStorage.setItem('locale', lang);

    nextTick(() => {
        if (husideRef.value && ensideRef.value) {
            if (lang === 'hu') {
                husideRef.value.classList.add('choosed-lang');
                ensideRef.value.classList.remove('choosed-lang');
            } else {
                ensideRef.value.classList.add('choosed-lang');
                husideRef.value.classList.remove('choosed-lang');
            }
        }
    });
};

const visible = ref(false);
watchEffect(() => {
    if (visible.value) checkLang();
});

</script>

<style scoped>
.center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.sidebar-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 1rem;
    /* background-color: #010207; */
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 1rem;
}

.branding {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.logo {
    height: 50px;
}

.close-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    color: #FEF7F8;
}

.menu-content {
    overflow-y: auto;
    padding-top: 1rem;
}

.menu-list,
.submenu-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.menu-section {
    display: flex;
    align-items: end;
}

.menu-section a {
    padding: 1rem;
    cursor: pointer;
    text-decoration: none;
    color: #FEF7F8;
}

.menu-section a:hover {
    font-weight: 500;
    transition: ease-in 200ms;
}


.menu-section a.router-link-exact-active {
    font-weight: 500;
}

.section-title {
    font-weight: 500;
    color: #666;
}

.menu-item {
    display: flex;
    align-items: center;
    padding: 0.75rem 1rem;
    border-radius: 0.25rem;
    color: #444;
    cursor: pointer;
    transition: background-color 0.15s ease-in-out;
}

.menu-item:hover {
    background-color: #f0f0f0;
}

.has-submenu .pi-chevron-down {
    margin-left: auto;
}

.footer {
    margin-top: auto;
    padding: 1rem;

}


.menu-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
}

.header-icons {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;
}

.header-icon {
    width: 25px;
    height: 25px;
    cursor: pointer;
    filter: invert(90%);
}

.langs {
    display: flex;
    gap: 20px;
}

.lang {
    filter: brightness(0.5);
    cursor: pointer;
    margin: 0;
    height: 20px;
    width: 30px;
    transition: ease-in-out 200ms;
}

.lang:hover {
    filter: brightness(1.2);
    transition: ease-in-out 200ms;
}

.choosed-lang {
    filter: brightness(1);
}
</style>
